import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { FormControl, UntypedFormGroup } from '@angular/forms';
import { ButtonClassesEnum } from '@types-custom/models/ui/button-model';
import { FilterTypes, IModuleFilter } from '@types-custom/models/ui/dynamic-filter';
import { Subscription } from 'rxjs';

@Component({
  selector: 'module-filter',
  templateUrl: './sit-filter.component.html',
  styleUrls: ['./sit-filter.component.scss'],
})
export class SitFilterComponent implements OnInit, OnDestroy {

  @Input() filterList: IModuleFilter[];
  @Input() reactiveUptade = false;
  @Output() filter = new EventEmitter<{ [key: string]: unknown }>();
  // @Output() onChange = new EventEmitter<{[key: string]: unknown}>();

  filterGroup = new UntypedFormGroup({});
  reactiveUpdater: Subscription;

  searchButtonAttributes = {
    label: 'BUSCAR',
    classAttributes: {
      buttonClass: ButtonClassesEnum.primary_filter_button,
    },
  };
  cleanbuttonAttributes = {
    label: 'LIMPIAR',
    classAttributes: {
      buttonClass: ButtonClassesEnum.secondary_filter_button,
    },
  };

  get type() {
    return FilterTypes;
  }


  ngOnInit(): void {
    this.filterList.forEach((f: IModuleFilter) => {
      const control = new FormControl(f.value ?? '');
      this.filterGroup.addControl(f.key, control);
    });
    if (this.reactiveUptade)
      this.reactiveUpdater = this.filterGroup.valueChanges.subscribe(vals => {
        this.filter.emit(this.cleanFilters(vals));
      });
  }

  ngOnDestroy(): void {
    if (this.reactiveUpdater)
      this.reactiveUpdater.unsubscribe();
  }

  control(key: string): FormControl {
    return this.filterGroup.controls[key] as FormControl;
  }


  onSearch() {
    this.filter.emit(this.cleanFilters(this.filterGroup.getRawValue()));
  }

  onClean() {
    Object.keys(this.filterGroup.controls).forEach(k => {
      this.filterGroup.controls[k].patchValue(null);
    });
    this.onSearch();
  }

  private cleanFilters(filters: any) {
    const filteredFilter = { ...filters };
    Object.keys(filteredFilter).forEach(k => {
      if (!filteredFilter[k] || !filteredFilter[k].length)
        delete filteredFilter[k];
    })
    return filteredFilter;
  }
}
